import * as React from 'react';
import {CSSProperties} from "react";
import styled from 'styled-components';
import Colours from '../State/Colours';
import devices from '../State/Devices';
import { ISelection } from '../Types/Model';
import { EditIcon, MinusCircle, PlusCircle } from './Icons';

interface ICollapsableSummaryProps {
    title: string
    total: string
    items: ISelection[]
    onEdit: () => void
}

interface ICollapsableSummaryState {
    expanded: boolean
}

const Header = styled.div`
    display: grid;
    font-size: 1.17em;
    grid-template-columns: auto 1fr auto;
    grid-column-gap: 4px; /* TODO */
    font-weight: bold;
    padding: 16px 16px;

    display: -ms-grid;
    -ms-grid-columns: auto 1fr auto;
    & *:nth-child(1) { -ms-grid-column: 1; }
    & *:nth-child(2) { -ms-grid-column: 2; }
    & *:nth-child(3) { -ms-grid-column: 3; }

    &:hover {
        background-color: ${Colours.panelBackground};
    }

    @media ${devices.laptop} {
        font-size: 1em;
        grid-template-columns: auto 1fr 1fr;
        padding: 16px 8px;

        -ms-grid-columns: auto 1fr 1fr;
    }
    
    .block {
        display: block;
    }
`;

const Total = styled.span`
    text-align: right;
`;

const getVisibility = ({ expanded }: IList) => {
    return expanded ? 'grid' : 'none';
};
const getIeVisibility = ({ expanded }: IList) => {
    return expanded ? '-ms-grid' : 'none';
};

const ListStyled = styled.div`
    display: ${getIeVisibility};
    display: ${getVisibility};
    padding: 16px;
    margin-top: 8px;
    margin-bottom: 32px;
    background-color: ${Colours.panelBackground};
    grid-template-columns: auto 1fr 1fr 1fr;
    grid-row-gap: 16px; /* TODO */
    grid-column-gap: 8px; /* TODO */
    -ms-grid-columns: auto 1fr 1fr 1fr;
    @media ${devices.laptop} {
        font-size: 0.8em;
        padding: 16px;
    }
    
    & *:nth-child(4n+1) { -ms-grid-column: 1; }
    & *:nth-child(4n+2) { -ms-grid-column: 2; }
    & *:nth-child(4n+3) { -ms-grid-column: 3; }
    & *:nth-child(4n+4) { -ms-grid-column: 4; }
    
    span {
        display: block;
    }
`;

const ListSubTotal = styled.span`
    text-align: right;
`;

interface IList {
    className: string
    expanded: boolean
    items: ISelection[]
    onEdit: () => void
}

const List = (props: IList) => (
    <ListStyled {...props}>
        {props.items.map((item, index) => {
            const style = { msGridRow: index + 1 } as CSSProperties;
            return (
                <React.Fragment key={index}>
                    <span style={style}>
                        <EditIcon onClick={props.onEdit}/>
                    </span>
                    <span style={style}>{item.name}</span>
                    <span style={style}>{item.value} {item.suffix}</span>
                    <ListSubTotal style={style}>{item.total}</ListSubTotal>
                </React.Fragment>
            )
        })}
    </ListStyled>
);

export default class CollapsableSummary extends React.Component<ICollapsableSummaryProps, ICollapsableSummaryState> {
    public state = {
        expanded: false,
    }

    public render() {
        const { title, total, items, onEdit } = this.props;
        const { expanded } = this.state;
        const onClick = () => this.setState({ expanded: !this.state.expanded });

        return (
            <div>
                <hr className="gray" style={{ margin: 0 }}/>

                <Header onClick={onClick} style={{ cursor: 'pointer'}}>
                    {items.length > 0 && (expanded ? <MinusCircle className="block"/> : <PlusCircle className="block"/>)}
                    {items.length === 0 && <span className="block"/>}
                    <span className="block">{title}</span>
                    <Total className="block">{total}</Total>
                </Header>

                {items.length > 0 && <List className="CollapsableSummaryList" expanded={expanded} items={items} onEdit={onEdit}/>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/CollapsableSummary.tsx